<div class="header-bar">
  <div class="flex">
    <div class="flex-grow-1">
      <h1>Service Delivery Groups</h1>
    </div>
    <div class="flex-shrink-1">
      <div class="pt-2">
        <button
          pButton
          class="button ui-button-success"
          icon="fa ui-icon-add"
          label="Add Service Group"
          (click)="addGroup()"
        ></button>
      </div>
    </div>
  </div>
</div>
<div class="content-container">
  <p-table
    [value]="serviceGroups"
    [responsive]="true"
    resizableColumns="true"
    class="fixed-table"
    selectionMode="none"
    [(selection)]="selectedGroup"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Telephone</th>
        <th>E-mail</th>
        <th>Updated</th>
        <th>Updated By</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <input
            pInputText
            [(ngModel)]="item.name"
            (change)="cellEdit(item)"
            [ngModelOptions]="{ standalone: true }"
            appendTo="body"
          />
        </td>
        <td>
          <input
            pInputText
            [(ngModel)]="item.telephone"
            (change)="cellEdit(item)"
            [ngModelOptions]="{ standalone: true }"
            appendTo="body"
          />
        </td>
        <td>
          <input
            pInputText
            [(ngModel)]="item.email"
            (change)="cellEdit(item)"
            [ngModelOptions]="{ standalone: true }"
            appendTo="body"
          />
        </td>
        <td>{{ item.updatedDate | datex : 'ddd DD MMM HH:mm' }}</td>
        <td>{{ item.updatedBy }}</td>
      </tr>
    </ng-template>
  </p-table>
  <!--
  <p-dataTabl [value]='serviceGroups' [responsive]='true' resizableColumns='true' class='fixed-table'
               selectionMode='none' [(selection)]='selectedGroup'>
    <p-column field='name' header='Name' [sortable]='false' [editable]='true'>
      <ng-template pTemplate='body' let-item='rowData'>
        <input pInputText [(ngModel)]='item.name'
               (change)='cellEdit(item)' [ngModelOptions]='{standalone: true}' appendTo='body' />
      </ng-template>
    </p-column>
    <p-column field='telephone' header='Telephone' [sortable]='false' [editable]='true'>
      <ng-template pTemplate='body' let-item='rowData'>
        <input pInputText [(ngModel)]='item.telephone'
               (change)='cellEdit(item)' [ngModelOptions]='{standalone: true}' appendTo='body' />
      </ng-template>
    </p-column>
    <p-column field='email' header='Email' [sortable]='false' [editable]='true'>
      <ng-template pTemplate='body' let-item='rowData'>
        <input pInputText [(ngModel)]='item.email'
               (change)='cellEdit(item)' [ngModelOptions]='{standalone: true}' appendTo='body' />
      </ng-template>
    </p-column>
    <p-column field="lastUpdated" header="Updated" [sortable]="true" [editable]="false">
      <ng-template pTemplate="body" let-item="rowData">
        {{ item.updatedDate | datex:'ddd DD MMM HH:mm' }}

      </ng-template>
    </p-column>
    <p-column field="updatedBy" header="Updated By" [sortable]="false" [editable]="false">
      <ng-template pTemplate="body" let-item="rowData">
        {{ item.updatedBy }}
      </ng-template>
    </p-column>
  </p-dataTable>
  -->
</div>

<p-dialog
  header="Add Service Delivery Group"
  [(visible)]="showAddDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '640px' }"
>
  <form [formGroup]="form" (ngSubmit)="addNewGroup()">
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-3">Group Name:</div>
        <div class="ui-g-9">
          <input pInputText formControlName="name" [style]="{ width: '100%' }" />
        </div>
        <div *ngIf="!form.controls['name'].valid" class="error-text">
          Enter a name for the group
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-3">Telephone:</div>
        <div class="ui-g-9">
          <input pInputText formControlName="telephone" [style]="{ width: '100%' }" />
        </div>
        <div *ngIf="!form.controls['telephone'].valid" class="error-text">
          Enter a valid telephone number
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-3">Email:</div>
        <div class="ui-g-9">
          <input
            type="email"
            [email]="true"
            pInputText
            formControlName="email"
            [style]="{ width: '100%' }"
          />
        </div>
        <div *ngIf="!form.controls['email'].valid" class="error-text">
          Enter a valid email address
        </div>
      </div>
    </div>

    <div style="float: right; margin-top: 50px; padding: 8px">
      <button type="submit" class="green-btn" pButton label="Add"></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        (click)="showAddDialog = false"
      ></button>
    </div>
  </form>
</p-dialog>
